var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllVideos = function SvgIllVideos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 128,
    viewBox: "0 0 375 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 1056,
    r: 1000,
    fill: "#3CC265"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1523_9600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 128,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1523_9600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1523_9600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -156,
    y: -12,
    width: 697,
    height: 136
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.77 55.7354C22.379 55.7354 -100.805 99.4005 -153.303 120.486L-156 -12H541L537.493 124C463.743 95.1835 340.816 55.7354 192.77 55.7354Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1523_9600)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.301 53.1293C314.301 53.1293 314.072 53.5453 314.778 53.4421L318.599 53.0762",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.344 62.2197C301.344 62.2197 301.089 60.7152 303.75 58.9355C306.41 57.1557 308.27 55.3134 309.041 54.3031C309.041 54.3031 308.656 52.8612 307.567 51.632L309.041 50.9251C309.041 50.9251 309.809 52.9519 310.162 52.8581C310.515 52.7643 310.643 52.489 310.643 51.9667V49.48L312.823 48.0381L315.036 50.4934C315.036 50.4934 314.715 52.3045 314.395 52.9175C314.075 53.5306 314.46 53.4711 314.781 53.4399L320.873 52.8581V54.9444L314.781 55.9077C314.607 55.9359 314.493 56.0923 314.529 56.2549C314.689 57.0306 315.029 59.1701 314.281 60.784C314.186 60.9873 314.232 61.1062 314.349 61.297C314.862 62.1259 316.049 64.8815 314.911 66.2703L312.957 67.0366L301.027 63.7836L301.348 62.2197H301.344Z",
    fill: "#ED1B98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311.158 57.2276C311.158 57.2276 310.812 56.1328 309.446 56.2767C308.079 56.4206 307.086 58.6226 308.03 59.5578C308.975 60.493 310.266 60.3179 311.292 58.4631",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.602 58.5101C308.602 58.5101 308.353 57.0838 309.474 56.9899C310.595 56.8961 310.978 59.3358 309.736 59.3827C308.494 59.4297 309 57.8782 309.474 57.8939C309.948 57.9095 309.978 58.9386 309.543 58.6696",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301.345 62.2194C301.345 62.2194 301.054 61.3217 302.551 59.8892C304.048 58.4566 305.483 58.0719 307.264 56.1858L309.042 54.2997L308.705 53.4083C308.705 53.4083 308.231 52.398 307.702 51.7881",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.47 51.9607C309.47 51.9607 308.339 51.92 308.438 52.8834L307.702 51.7949L307.467 51.1975L309.039 50.9316L309.467 51.9638L309.47 51.9607Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310.644 50.6778V51.4285C310.644 51.4285 311.85 50.1586 314.929 51.0532L315.481 49.874L311.801 47.3467L309.971 50.1555L310.641 50.6778H310.644Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.23 53.0175C319.23 53.0175 320.116 53.8777 319.066 55.2321L320.688 54.9568L320.635 52.833L319.23 53.0175V53.0175Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.355 43.9227C295.355 43.9227 297.963 43.53 299.805 45.069L301.691 43.2017C301.691 43.2017 297.583 42.5658 296.869 41.4036L295.18 42.3473L295.358 43.9219L295.355 43.9227Z",
    fill: "#ED1B98",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.359 51.6715C324.248 49.9763 320.189 48.8127 319.931 53.6483C319.709 54.7431 319.228 56.8262 321.702 57.6739C324.176 58.5215 325.428 57.1797 325.503 55.6971C325.503 55.6971 327.755 55.6627 327.791 53.5795C327.827 51.4964 325.098 51.0366 324.359 51.6715Z",
    fill: "#32BF5E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.827 49.2423C312.827 49.2423 306.934 54.2907 301.802 50.7437C296.671 47.1967 298.429 39.74 304.747 39.5116C304.747 39.5116 306.362 35.2359 312.827 36.5558C312.827 36.5558 314.252 31.7796 320.762 32.0079C327.273 32.2363 327.224 38.298 327.224 38.298C327.224 38.298 332.306 40.0621 330.263 45.9237C328.266 50.2057 324.848 50.3809 321.994 49.4707C321.994 49.4707 318.716 53.6995 312.823 49.2423H312.827Z",
    fill: "#32BF5E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.998 49.4691C321.998 49.4691 318.7 48.953 318.213 44.9932",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.286 46.2178C315.286 46.2178 314.132 48.62 312.828 49.3018",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M317.338 32.4238C317.338 32.4238 312.992 33.7625 312.828 36.5557Z",
    fill: "#32BF5E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M317.338 32.4238C317.338 32.4238 312.992 33.7625 312.828 36.5557",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M299.677 42.2432C299.625 42.3558 299.576 42.4652 299.53 42.5778C296.847 48.9555 302.831 51.342 302.831 51.342",
    fill: "#32BF5E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M299.677 42.2432C299.625 42.3558 299.576 42.4652 299.53 42.5778C296.847 48.9555 302.831 51.342 302.831 51.342",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.283 39.1738C294.283 39.1738 292.58 37.0052 290.3 39.0468C288.019 41.0885 291.36 42.7644 291.36 42.7644C291.36 42.7644 290.746 44.8894 292.409 45.4927C294.072 46.096 295.365 45.0223 296.402 42.9584C297.44 40.8944 297.97 40.8661 297.448 39.0345C296.926 37.2028 294.109 38.2433 294.282 39.1707L294.283 39.1738Z",
    fill: "#32BF5E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M297.574 42.8953C297.574 42.8953 297.228 42.6758 296.523 42.6889C295.818 42.702 294.928 42.8134 294.928 42.1384C294.928 41.4635 295.143 40.7754 295.188 40.2413C295.232 39.7073 295.143 38.246 295.763 38.2067C296.383 38.1673 296.54 38.5081 296.653 39.0585C296.653 39.0585 297.04 38.1116 297.585 38.1968C298.129 38.282 298.081 38.4688 298.19 39.2519C298.276 39.514 298.204 39.6516 298.779 39.8023C299.355 39.953 300.95 40.2708 302.056 41.6469C302.501 42.335 302.487 44.5073 300.721 44.9758C298.954 45.4444 298.451 44.8382 298.42 44.2616C298.399 43.8455 298.519 43.5768 298.711 43.4293C298.783 43.3736 298.865 43.3343 298.954 43.3114C299.269 43.2295 299.574 43.1312 299.574 43.1312C299.574 43.1312 298.495 43.2262 297.574 42.8986V42.8953Z",
    fill: "#F6D703"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1523_9600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 38,
    width: 9,
    height: 8
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M297.574 42.8953C297.574 42.8953 297.228 42.6758 296.523 42.6889C295.818 42.702 294.928 42.8134 294.928 42.1384C294.928 41.4635 295.143 40.7754 295.188 40.2413C295.232 39.7073 295.143 38.246 295.763 38.2067C296.383 38.1673 296.54 38.5081 296.653 39.0585C296.653 39.0585 297.04 38.1116 297.585 38.1968C298.129 38.282 298.081 38.4688 298.19 39.2519C298.276 39.514 298.204 39.6516 298.779 39.8023C299.355 39.953 300.95 40.2708 302.056 41.6469C302.501 42.335 302.487 44.5073 300.721 44.9758C298.954 45.4444 298.451 44.8382 298.42 44.2616C298.399 43.8455 298.519 43.5768 298.711 43.4293C298.783 43.3736 298.865 43.3343 298.954 43.3114C299.269 43.2295 299.574 43.1312 299.574 43.1312C299.574 43.1312 298.495 43.2262 297.574 42.8986V42.8953Z",
    fill: "#F6D703"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1523_9600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.063 42.1347C300.971 42.1347 301.707 41.4305 301.707 40.562C301.707 39.6934 300.971 38.9893 300.063 38.9893C299.156 38.9893 298.42 39.6934 298.42 40.562C298.42 41.4305 299.156 42.1347 300.063 42.1347Z",
    fill: "url(#paint0_radial_1523_9600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.415 43.0331C295.322 43.0331 296.058 42.329 296.058 41.4604C296.058 40.5918 295.322 39.8877 294.415 39.8877C293.507 39.8877 292.771 40.5918 292.771 41.4604C292.771 42.329 293.507 43.0331 294.415 43.0331Z",
    fill: "url(#paint1_radial_1523_9600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.608 46.3876C300.516 46.3876 301.252 45.6835 301.252 44.8149C301.252 43.9463 300.516 43.2422 299.608 43.2422C298.701 43.2422 297.965 43.9463 297.965 44.8149C297.965 45.6835 298.701 46.3876 299.608 46.3876Z",
    fill: "url(#paint2_radial_1523_9600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.151 43.9932C302.862 43.9932 303.438 43.4416 303.438 42.7613C303.438 42.0809 302.862 41.5293 302.151 41.5293C301.44 41.5293 300.863 42.0809 300.863 42.7613C300.863 43.4416 301.44 43.9932 302.151 43.9932Z",
    fill: "url(#paint3_radial_1523_9600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.738 43.9932C298.449 43.9932 299.026 43.4416 299.026 42.7613C299.026 42.0809 298.449 41.5293 297.738 41.5293C297.028 41.5293 296.451 42.0809 296.451 42.7613C296.451 43.4416 297.028 43.9932 297.738 43.9932Z",
    fill: "url(#paint4_radial_1523_9600)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.738 39.6983C298.449 39.6983 299.026 39.1467 299.026 38.4663C299.026 37.7859 298.449 37.2344 297.738 37.2344C297.028 37.2344 296.451 37.7859 296.451 38.4663C296.451 39.1467 297.028 39.6983 297.738 39.6983Z",
    fill: "url(#paint5_radial_1523_9600)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M297.201 40.3198C297.453 40.3198 297.657 40.1247 297.657 39.884C297.657 39.6433 297.453 39.4482 297.201 39.4482C296.95 39.4482 296.746 39.6433 296.746 39.884C296.746 40.1247 296.95 40.3198 297.201 40.3198Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M297.095 40.2582C297.288 40.2582 297.445 40.1086 297.445 39.924C297.445 39.7395 297.288 39.5898 297.095 39.5898C296.902 39.5898 296.746 39.7395 296.746 39.924C296.746 40.1086 296.902 40.2582 297.095 40.2582Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M296.262 40.376C296.262 40.376 296.426 40.7659 296.809 40.4022",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M296.032 40.2202C296.283 40.2202 296.487 40.0251 296.487 39.7844C296.487 39.5437 296.283 39.3486 296.032 39.3486C295.78 39.3486 295.576 39.5437 295.576 39.7844C295.576 40.0251 295.78 40.2202 296.032 40.2202Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M295.925 40.1577C296.118 40.1577 296.275 40.008 296.275 39.8235C296.275 39.6389 296.118 39.4893 295.925 39.4893C295.733 39.4893 295.576 39.6389 295.576 39.8235C295.576 40.008 295.733 40.1577 295.925 40.1577Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M297.588 38.1971C297.588 38.1971 298.04 38.1381 298.119 38.6951C298.197 39.2521 297.814 39.6158 299.108 39.8845C300.402 40.1532 301.347 40.7888 301.857 41.4081L301.977 41.5424",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7051 46.9615V45.5033L68.9708 44L70.4741 45.4787V46.9615",
    fill: "#ED1B98"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9707 44H74.0417L75.4958 45.4541L70.474 45.4787L68.9707 44Z",
    fill: "#0066FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4964 45.4541H70.4746V47.0925H75.4964V45.4541Z",
    fill: "#FCAEE0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3162 49.1289L55 57.2024H58.3916L64.4252 51.1688L61.3162 49.1289Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9148 56.7971V65.9642H69.9102V54.6016L83.9148 56.7971Z",
    fill: "#FCAEE0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7188 55.4658L71.4432 57.518H83.8299V66.509",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0605 65.9643V54.4952L62.959 47.0566L69.8527 55.1997V65.4728L57.0605 65.9643Z",
    fill: "#ED1B98"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7766 53.2455C63.5118 53.2455 64.1078 52.6495 64.1078 51.9142C64.1078 51.179 63.5118 50.583 62.7766 50.583C62.0413 50.583 61.4453 51.179 61.4453 51.9142C61.4453 52.6495 62.0413 53.2455 62.7766 53.2455Z",
    fill: "#F6D703"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7609 55.2031H57.2637V65.9677H69.7609V55.2031Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7609 55.2031L57.2637 65.9677",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7609 65.9677L57.2637 55.2031",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9375 47.0592L63.0358 46.9609L71.5844 57.1029L85.9208 57.1439V57.3282L71.5639 57.3569L62.9375 47.0592Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2159 46.9482L63.0352 46.9605L71.5838 57.1025L85.9202 57.1435L77.2159 46.9482Z",
    fill: "#0066FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M289.012 61.1162C289.012 61.1162 314.658 64.0147 328.561 66.2872",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7926 77.0088C17.7926 77.0088 14.907 75.6512 14.9637 73.511C15.0204 71.3708 17.8493 73.057 18.307 75.0804C18.307 75.0804 18.0019 71.9458 19.9808 69.9267C21.9597 67.9075 22.8097 69.3559 22.6877 70.5579C22.5656 71.7599 22.7182 74.0557 20.1334 76.2867L17.7926 77.0088V77.0088Z",
    fill: "#3CC265"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9 58.3013C136.9 58.3013 135.661 57.3329 135.98 56.2044C136.3 55.0759 137.136 55.4448 137.219 56.6086C137.219 56.6086 137.986 54.4086 139.391 54.9376C140.797 55.4665 138.116 58.3935 137.753 58.3718C137.389 58.3501 136.903 58.304 136.903 58.304L136.9 58.3013Z",
    fill: "#32BF5E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M344.678 71.4907C344.678 71.4907 342.724 70.3373 343.033 67.4668C343.342 64.5964 344.575 65.3328 344.851 66.0316C345.127 66.7304 345.602 68.4512 345.429 68.8908C345.337 69.1237 345.62 69.3229 345.745 68.9396C345.87 68.2596 345.37 66.9784 345.469 66.3848C345.568 65.7912 346.533 61.8011 347.901 62.0077C349.27 62.2144 347.386 68.098 346.599 68.8344C346.599 68.8344 348.45 66.9108 349.443 67.6434C350.437 68.3761 348.107 71.4945 346.393 71.4945H344.678V71.4907Z",
    fill: "#3CC265"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1306 80.2338C72.1306 80.2338 79.0146 77.5839 84.3358 81.8877C84.3358 81.8877 89.4463 77.0299 97.607 80.4266C97.607 80.4266 102.325 76.2774 110.371 77.3977C110.371 77.3977 104.552 74.917 98.2619 77.5577C98.2619 77.5577 90.1737 73.4827 83.4477 78.8989C83.4477 78.8989 78.9254 77.2939 72.1271 80.2339L72.1306 80.2338Z",
    fill: "#F6D703"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M322.398 95.8408C322.398 95.8408 329.212 94.6996 333.292 99.647C333.292 99.647 338.895 96.1465 345.748 100.793C345.748 100.793 350.857 97.868 358.033 100.409C358.033 100.409 353.156 97.0393 346.886 98.2848C346.886 98.2848 340.226 93.0268 333.039 96.7383C333.039 96.7383 329.19 94.4163 322.398 95.8408V95.8408Z",
    fill: "#F6D703"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M274.846 75.1782C274.846 75.1782 282.799 74.3223 287.284 80.1345C287.284 80.1345 293.946 76.5532 301.662 82.202C301.662 82.202 307.724 79.2374 315.916 82.5356C315.916 82.5356 310.429 78.4479 303.104 79.4536C303.104 79.4536 295.641 73.1329 287.13 76.8505C287.13 76.8505 282.781 74.0028 274.842 75.1773L274.846 75.1782Z",
    fill: "#F6D703"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1523_9600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(300.063 40.562) scale(1.64336 1.57271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC1E98",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EC1E98",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EC1E98",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EC1E98",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC1E98",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1523_9600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.415 41.4604) scale(1.64336 1.57271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EC1E98",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EC1E98",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EC1E98",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EC1E98",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EC1E98",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1523_9600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.608 44.8149) scale(1.64336 1.5727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EC1E98",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EC1E98",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EC1E98",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EC1E98",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1523_9600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(302.151 42.7612) scale(1.28729 1.23195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#32CDF1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32CDF1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#32CDF1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#32CDF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1523_9600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.738 42.7612) scale(1.28729 1.23195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#32CDF1",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32CDF1",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#32CDF1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1523_9600",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.738 38.4663) scale(1.28729 1.23195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32CDF1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32CDF1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32CDF1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32CDF0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllVideos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_videos.f5abef9e.svg";
export { ForwardRef as ReactComponent };